module.exports = __webpack_public_path__ + "files/6b3473e1b9c6d45ae4de88ab403e6c7c.png";